export default __webpack_public_path__ + "static/media/ic-user-profile.aafb2405.svg";